import { z } from "zod";

export const baseFields = {
  full_name: z.string().min(1, "O nome completo é obrigatório."),
  email: z.string().email("Digite um e-mail válido."),
  password: z.string().min(6, "A senha deve ter no mínimo 6 caracteres."),
  password_confirmation: z
    .string()
    .min(6, "A confirmação da senha deve ter no mínimo 6 caracteres."),
  phone: z.string().min(10, "Digite um número de WhatsApp válido."),
  cep: z.string().min(9, "Digite um CEP válido."),
  user_type: z.string().min(1, "Selecione um tipo de acesso."),
  
  // Torna os campos preenchidos via CEP opcionais no Zod,
  // mas serão refinados abaixo
  street: z.string().optional(),
  district: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),

  number: z.string().min(1, "O número do endereço é obrigatório."),
  complement: z.string().min(1, "O complemento é obrigatório."),
  
  accept_terms_of_use: z.literal(true, {
    errorMap: () => ({
      message: "Você deve aceitar os termos de uso.",
    }),
  }),
  accept_privacy_politics: z.literal(true, {
    errorMap: () => ({
      message: "Você deve aceitar a política de privacidade.",
    }),
  }),
};

export const registerUserSchema = z
  .discriminatedUnion("personType", [
    z.object({
      personType: z.literal("fisica"),
      rg: z.string().min(1, "O RG é obrigatório."),
      cpf: z.string().min(1, "O CPF é obrigatório."),
      cnpj: z.string().optional(),
      ...baseFields,
    }),
    z.object({
      personType: z.literal("juridica"),
      rg: z.string().optional(),
      cpf: z.string().optional(),
      cnpj: z.string().min(1, "O CNPJ é obrigatório."),
      ...baseFields,
    }),
  ])
  .refine((data) => data.password === data.password_confirmation, {
    message: "As senhas não coincidem.",
    path: ["password_confirmation"],
  })
  .refine((data) => {
    if (data.cep?.length < 9) return true; // Se o CEP não foi preenchido corretamente, permite
    // Valida se os campos de endereço estão preenchidos após a API ter sido chamada
    return (
      !!data.street?.trim() &&
      !!data.district?.trim() &&
      !!data.city?.trim() &&
      !!data.state?.trim()
    );
  }, {
    message: "Preencha o endereço completo com base no CEP.",
    path: ["cep"],
  });

/** Cadastro ENG/ADM de PROP ou GUARDIAN: nome, e-mail, tipo e papéis de área. */
export const FIELD_AREA_ROLES = {
  TEAM: "TEAM",
  MANAGER: "MANAGER",
};

export const fieldUserCreateSchema = z.object({
  full_name: z.string().min(1, "O nome completo é obrigatório."),
  email: z.string().email("Digite um e-mail válido."),
  user_type: z.enum(["PROP", "GUARDIAN"], {
    errorMap: () => ({ message: "Selecione PROP ou GUARDIAN." }),
  }),
});

